import type { CustomerRegistrationResponseFragment } from '@/graphql/api'
import { useRouterNavigation } from '@/plugins/released-urls/useRouterNavigation'
import { useAuth } from '@/plugins/auth.ts'
import { useRedirect } from 'wucdbm-vite-vue-ssr'

export type ResponseData = {
    customer?: CustomerRegistrationResponseFragment
}

interface HandleFormSubmitResponse {
    handleFormSubmitResponse(data: ResponseData, redirect?: string | null): void
}

export function useHandleFormSubmitResponse(
    redirectToRoute: string
): HandleFormSubmitResponse {
    const { setAuth, setLoginMessage } = useAuth()
    const { routerPush } = useRouterNavigation()
    const performRedirect = useRedirect()

    const handleFormSubmitResponse = (
        data: ResponseData,
        redirect?: string | null
    ) => {
        if (data.customer) {
            setAuth(data.customer.login)
        } else {
            // TODO Translate
            setLoginMessage(
                "We've added this enquiry to your existing account."
            )
        }

        if (redirect) {
            performRedirect(redirect)
        } else {
            routerPush({ name: redirectToRoute }).catch(() => {
                //
            })
        }
    }

    return { handleFormSubmitResponse }
}
